import * as React from "react";

import {
    formatDateTimeAndTimezone,
    formatUserName,
} from "@impero-com/common/utils/formatting";
import { t } from "@impero-com/common/utils/i18n";
import { assertNever } from "@impero-com/common/utils/obj";
import { Button, InfoTooltip, renderMarkdown } from "@impero-com/ui";
import Checkbox from "antd/es/checkbox";

import { AssessmentStatus, Assessed } from "../types";

import * as theme from "./theme.css";

class AssessmentCheckbox extends React.Component<
    AssessmentCheckboxProps,
    AssessmentCheckboxState
> {
    state = { disabled: this.props.disabled, checked: false };

    render() {
        const { status } = this.props;
        if (status.assessmentStatus === "assessed") {
            return this.renderAssessed(status);
        } else if (status.assessmentStatus === "unassessed") {
            return this.renderUnassessed();
        } else {
            return assertNever(status);
        }
    }

    renderAssessed(assessed: Assessed) {
        const {
            at,
            timezone,
            user: {
                content: { resource: user },
            },
        } = assessed;
        const { disabled } = this.state;
        return (
            <div className={theme.footer}>
                <Checkbox defaultChecked disabled />
                <div className={theme.assessedContainer}>
                    <div className={theme.assessedLabelContainer}>
                        {renderMarkdown(
                            t("RiskMaps_Edit_AssessedByUser", {
                                user: formatUserName(user),
                            })
                        )}
                        <InfoTooltip
                            size="small"
                            text={t("RiskMaps_Edit_Assessed_CheckboxTooltip")}
                        />
                    </div>
                    <div>{formatDateTimeAndTimezone(at, timezone)}</div>
                </div>
                <div className={theme.reassessButton}>
                    <Button
                        variant="link"
                        disabled={disabled}
                        onClick={this.onToggle}
                    >
                        {t("RiskMaps_Edit_Reassess")}
                    </Button>
                </div>
            </div>
        );
    }

    renderUnassessed() {
        const { disabled, checked } = this.state;
        return (
            <div className={theme.footer}>
                <Checkbox
                    checked={checked}
                    disabled={disabled}
                    onChange={this.onToggle}
                >
                    {t("RiskMaps_Edit_MarkAsAssessed")}
                </Checkbox>
                <InfoTooltip
                    size="small"
                    text={t("RiskMaps_Edit_Unassessed_CheckboxTooltip")}
                />
            </div>
        );
    }

    onToggle = () => {
        this.setState(() => {
            return { disabled: true };
        });
        try {
            this.props.onToggle();
        } catch {
            this.setState(() => {
                return { disabled: false, checked: false };
            });
        }
    };
}

interface AssessmentCheckboxState {
    disabled: boolean;
    checked: boolean;
}

interface AssessmentCheckboxProps {
    status: AssessmentStatus;
    disabled: boolean;
    onToggle: () => void;
}

export default AssessmentCheckbox;
